import type { HbBidderConfig } from '../types'

const PUBLISHER_ID = '25cv68n329154k1909176mw4'

export const OMNIDEX_BANNER: HbBidderConfig = {
    bidder: 'omnidex',
    params: {
        pId: PUBLISHER_ID,
        cId: '6a5a41780561984146c49b39',
    },
}

export const OMNIDEX_VIDEO: HbBidderConfig = {
    bidder: 'omnidex',
    params: {
        pId: PUBLISHER_ID,
        cId: '6a5a41c218ca3811d266fc9d',
    },
}
